<div class="pag-container" *ngIf="showTable">

  <app-campaign-3-breadcrumb #breadcrumbComponent [arrayBreadcrumbs]="breadcrumbs"
                             (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink="">
  </app-campaign-3-breadcrumb>




  <div class="ui-g-12 vertical-margin-20">
    <div class="ui-g-6 no-lateral-padding">
      <h1 class="title">{{ 'challenge.challengeCreation' | translate }}</h1>
    </div>

    <div class="ui-g-6 d-flex justify-content-end">
      <button class="btn-page-act" style="margin-right: 10px;" (click)="onBackAction()">
        <i class="pi pi-arrow-left margin-fit"></i>

        <span>{{ 'challenge.back' | translate }}</span>
      </button>
      <button class="btn-page-act" (click)="onSaveChallenge()" [disabled]="readOnly"
              [ngClass]="{'disabled': readOnly}">
        <i class="pi pi-save margin-fit"></i>

        <span>{{ 'challenge.save' | translate }}</span>
      </button>
    </div>
  </div>
  <div *ngIf="readOnly" class="warning-readonly">
    <i class="pi pi-exclamation-triangle"></i>
    {{ 'challenge.impossible_to_edit' | translate }}
  </div>

  <div class="ui-g-12 vertical-margin-10 no-lateral-padding">
    <!-- RIGA 1 -->
    <!-- titolo, descrizione e tipo -->
    <div class="ui-g-4">
      <app-form-fields #titleField [(fieldModel)]="fieldModel.title" data-testid="titleField" [type]="'string'"
                       [label]="'challenge.title' | translate" [name]="'title'"
                       [placeholder]="'challenge.enter_title' | translate" [required]="true" [disabled]="readOnly" [maxLength]="50">
      </app-form-fields>
    </div>

    <div class="ui-g-4">
      <app-form-fields #descriptionField [(fieldModel)]="fieldModel.description" data-testid="descriptionField"
                       [type]="'string'" [label]="'challenge.description' | translate" [name]="'description'"
                       [placeholder]="'challenge.insert_description' | translate" [required]="true" [disabled]="readOnly" [maxLength]="255">
      </app-form-fields>
    </div>

    <div class="ui-g-4">
      <app-form-fields #kindField [(fieldModel)]="fieldModel.kind" data-testid="kindField" [type]="'dropdown'"
                       [label]="'challenge.kind' | translate" [name]="'kind'" [optionLabel]="'label'" [options]="combotype"
                       [placeholder]="'challenge.select_kind' | translate" [required]="true"
                       (fieldModelChange)="handleSelectType($event)" [disabled]="readOnly">
      </app-form-fields>
    </div>

    <!-- RIGA 2 -->
    <div class="ui-g-4">
      <app-form-fields #dateStartField [(fieldModel)]="fieldModel.dateStart" data-testid="dateStartField"
                       [type]="'date'" [label]="'challenge.startDate' | translate" [name]="'dateStart'"
                       [placeholder]="'challenge.select_start_date' | translate" [required]="true"
                       (fieldModelChange)="onDateChange()" [minDate]="today" [disabled]="readOnly">
      </app-form-fields>
    </div>

    <div class="ui-g-4">
      <app-form-fields #dateEndField [(fieldModel)]="fieldModel.dateEnd" data-testid="dateEndField"
                       [type]="'date'" [label]="'challenge.endDate' | translate" [name]="'dateEnd'"
                       [placeholder]="'challenge.select_end_date' | translate" [required]="false"
                       (fieldModelChange)="onDateChange()" [minDate]="today" [disabled]="readOnly">
      </app-form-fields>
    </div>

    <div class="ui-g-4">
      <app-form-fields #priorityField [(fieldModel)]="fieldModel.priority" data-testid="priorityField"
                       [type]="'number'" [label]="'challenge.priority' | translate" [name]="'priority'"
                       [placeholder]="'challenge.enter_priority' | translate" [required]="true" [maxValue]="100" [minValue]="0"
                       [disabled]="readOnly">
      </app-form-fields>
    </div>


    <!-- RIGA 3-->
    <!-- cluster e template -->

    <div class="ui-g-12 vertical-margin-10 no-lateral-padding">

      <div class="ui-g-1">
        <div class="label-switch">{{ 'challenge.flg_acceptance' | translate }}</div>
        <app-form-fields #flgAcceptanceField [(fieldModel)]="fieldModel.flg_acceptance"
                         data-testid="flgAcceptanceField" [type]="'switch'"
                         [placeholder]="'challenge.enter_flag_acceptance' | translate"
                         (fieldModelChange)="onAcceptanceFlagChange($event)" [disabled]="readOnly">
        </app-form-fields>
      </div>

      <div class="ui-g-5">
        <app-form-fields #acceptanceClusterField [(fieldModel)]="fieldModel.acceptance_cluster"
                         data-testid="acceptanceClusterField" [type]="'dropdown'"
                         [label]="'challenge.acceptanceCluster' | translate" [name]="'acceptance_cluster'"
                         [options]="clusterList" [optionLabel]="'label'" [filterable]="true"
                         [placeholder]="'challenge.select_acceptance_cluster' | translate"
                         [disabled]="readOnly || !fieldModel.flg_acceptance" [required]="fieldModel.flg_acceptance">
        </app-form-fields>
      </div>

      <div class="ui-g-6">
        <app-form-fields #templateField [(fieldModel)]="fieldModel.template" data-testid="templateField"
                         [type]="'dropdown'" [label]="'challenge.template' | translate" [name]="'template'"
                         [optionLabel]="'label'" [filterable]="true" [options]="templateDropdownList"
                         [placeholder]="'challenge.select_template' | translate" [required]="true"
                         (fieldModelChange)="onTemplateChange($event)" [disabled]="readOnly || !fieldModel.kind">
        </app-form-fields>
      </div>

    </div>

    <!-- RIGA 4 -->
    <!-- notifiche push -->
    <div class="ui-g-12 vertical-margin-10 no-lateral-padding">
      <div class="ui-g-1">
        <div class="label-switch" style="margin-bottom:20px">{{ 'challenge.pushNotify' | translate }}</div>
        <app-form-fields #pushNotify data-testid="pushNotifyField" [type]="'switch'"
                         [(fieldModel)]="fieldModel.pushNotify" [required]="false"
                         (fieldModelChange)="onPushNotifyChange($event)" [disabled]="readOnly || !isPushNotificationEnabled">
        </app-form-fields>
      </div>

      <div class="ui-g-5">
        <app-form-fields #pushNotifyText data-testid="pushNotifyTextField"
                         [(fieldModel)]="fieldModel.pushNotifyText" [type]="'string'"
                         [label]="'challenge.pushNotifyText' | translate" [name]="'pushNotifyText'"
                         [placeholder]="'challenge.pushNotifyText' | translate"
                         [disabled]="readOnly || !fieldModel.pushNotify || !isPushNotificationEnabled"
                         [required]="fieldModel.pushNotify">
        </app-form-fields>
      </div>

      <div class="ui-g-3">
        <app-form-fields #dayBeforeNotifyPushField [(fieldModel)]="fieldModel.dayBeforeNotifyPush"
                         data-testid="dayBeforeNotifyPushField" [type]="'number'"
                         [label]="'challenge.dayBeforeNotifyPush' | translate" [name]="'dayBeforeNotifyPush'"
                         [placeholder]="'challenge.enter_dayBeforeNotifyPush' | translate" [required]="fieldModel.pushNotify"
                         [disabled]="readOnly || !fieldModel.pushNotify">
        </app-form-fields>
      </div>
      <div class="ui-g-3">
        <app-form-fields #notifyPushHourField [(fieldModel)]="fieldModel.notifyPushHour"
                         data-testid="notifyPushHourField" [type]="'time'" [label]="'challenge.notifyPushHour' | translate"
                         [name]="'notifyPushHour'" [placeholder]="'HH:mm'" [required]="fieldModel.pushNotify"
                         [disabled]="readOnly || !fieldModel.pushNotify">
        </app-form-fields>

      </div>
    </div>

  </div>

  <!-- bottone per aggiungere nuovo accumulatore -->
  <div class="ui-g-12 flexCenter">
    <div class="ui-g-3">
      <button class="btn-page-act" style="margin-right: 10px;" (click)="onAddAccumulator()"
              data-testid="addAccumulatorBtn" [disabled]="readOnly" [ngClass]="{'btn-disabled': readOnly}">
        <i class="pi pi-plus-circle margin-fit"></i>
        <span>{{ 'challenge.addAccumulator' | translate }}</span>
      </button>
    </div>
    <!-- and or button -->
    <div class="ui-g-6 and-or-toggle">
      <label class="and-or-label">
        {{ 'challenge.logical_conditions' | translate }} :
      </label>
      <div class="buttons-row">
        <button [class.active]="useAnd" (click)="useAnd = true" data-testid="andBtn"
                [ngClass]="{'btn-disabled': readOnly}" [disabled]="readOnly">
          {{ 'challenge.all' | translate }}
        </button>
        <button [class.active]="!useAnd" (click)="useAnd = false" data-testid="orBtn"
                [ngClass]="{'btn-disabled': readOnly}" [disabled]="readOnly">
          {{ 'challenge.at_least_one' | translate }}
        </button>
      </div>
    </div>
    <div class="ui-g-3">
    </div>
  </div>


  <!-- Titolo -->
  <h3 class="title">{{ 'challenge.accumulator' | translate }}</h3>

  <!-- lista degli accumulatori selezionati -->
  <div class="ui-g-12" *ngIf="selectedAcm.length > 0">
    <div *ngFor="let acm of selectedAcm; let i = index" class="ui-g-12 accumulator-item">
      <div class="accumulator-card">
        <div class="accumulator-info">
          <div><strong>{{ 'challenge.channel' | translate }}:</strong> {{ acm.channelDescription }}</div>
          <div><strong>{{ 'challenge.code' | translate }}:</strong> {{ acm.acm_code }}</div>
          <div><strong>{{ 'challenge.description' | translate }}:</strong> {{ acm.acmDescription }}</div>
        </div>
        <div class="accumulator-actions">
          <button class="remove-btn" (click)="removeAccumulator(i)" [disabled]="readOnly">
            &times; <!-- croce di chiusura -->
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- se non ci sono accumulatori -->
  <div class="ui-g-12" *ngIf="selectedAcm.length === 0">
    {{ 'challenge.no_acm_selected' | translate }}
  </div>
  <div class="ui-g-6">

    <h3 class="title">{{ 'challenge.touchpoint' | translate }}</h3>
    <div *ngIf="!fieldModel.template" class="warning-box">
      <i class="fa fa-exclamation-triangle warning-icon"></i>
      <span>{{ 'challenge.no_template_selected' | translate }}</span>
    </div>
    <div class="ui-g-12">
      <div>
        <button pButton type="button" [ngClass]="{'layoutDone': fieldModel.layoutDefaultValue }"
                class="layoutDefaultFirstBtn" icon="fa fa-edit" iconPos="left" label="Layout default"
                (click)="onClickLayoutDefault()" [disabled]="!fieldModel.template || readOnly"></button>
        <br />
        <br />
        <div *ngIf="!challengeTouchpointValid" class="errorMessage">{{'challenge.required_tp_error' |
          translate}}</div>
      </div>
    </div>
    <!-- wrapper scrollabile -->
    <div class="touchpoint-scrollable" [ngClass]="{'notPermitted': readOnly==true}">
      <div class="touchpoint-scrollable" [ngClass]="{'notPermitted': readOnly==true}">
        <div *ngFor="let tp of touchpointList; let i = index;" class="generalList ui-g-12 flex-gap">

          <div class="ui-g-6 colTouchpoint">
            <button pButton type="button" [ngClass]="{
                    'colTouchpointDone': tp.active == true,
                    'colTouchpointInactive': tp.active == false,
                    'btn-disabled': readOnly
                 }" class="touchpointNameButton" label="{{tp.description}}" (click)="onClickTouchpointNameButton(i)"
                    [disabled]="tp.templateValue || readOnly">
            </button>
          </div>

          <div class="ui-g-6 colTouchpoint justify-content-start" *ngIf="tp.active==true">
            <button pButton type="button" [attr.data-testid]="'colTouchpointChallenge' + tp.code" [ngClass]="{
                    'colTouchpointDone': tp.active == true,
                    'colTouchpointInactive': tp.active == false
                                }" class="layoutBtn justify-content-start" icon="fa fa-edit" iconPos="left"
                    label="Layout" (click)="onClickLayoutBtn(i)" [disabled]="!fieldModel.template || readOnly">
            </button>

            <button pButton type="button" icon="fa fa-trash" class="delete-touchpoint-btn" iconPos="left"
                    label="Reset" (click)="onClickDeleteLayoutBtn(i)" *ngIf="tp.templateValue"
                    [ngClass]="{'btn-disabled': readOnly}" [disabled]="!fieldModel.template || readOnly">
            </button>

          </div>

        </div>
      </div>

    </div>
  </div>




  <!-- liste di distribuzione -->
  <div class="ui-g-6">
    <h3 class="title"> {{ 'challenge.distributionList' | translate }}
    </h3>
    <div class="ui-g-12" *ngIf="distributionList.length>0">

      <div class="ui-g ui-g-align-center"> <!-- Usa la classe per centrare verticalmente -->
        <div class="ui-g-1" style="margin-top:10px">
          <button type="button" class="fa fa-search circleIcon" (click)="onClickSearchListaDistribuzione()"
                  [disabled]="readOnly" [ngClass]="{'btn-disabled': readOnly}">
          </button>
        </div>
        <div class="ui-g-11">
          <app-form-fields style="margin-bottom:15px" #listaDistribuzioneChallenge
                           data-testid="listaDistribuzioneChallenge" [readOnly]="readOnly" [showLabel]="false"
                           [(fieldModel)]="selectedDistributionList" [type]="'dropdown'" [options]="distributionList"
                           [filterable]="true" [optionLabel]="'distributionListName'" [disabled]="readOnly"
                           [placeholder]="'campaign.select_distribution_list' | translate"
                           [ngClass]="{'disabled': readOnly}"></app-form-fields>
        </div>
      </div>

    </div>
    <div class="ui-g-12">
      <br />
      <button pButton type="button" data-testid="showChallengeDistributionListContentBtn"
              class="buttonActions buttonVisualizzaContenuto" icon="fa fa-eye" iconPos="left"
              label="{{'campaign.view_content_list' | translate}}" [ngClass]="{'notPermitted': !selectedDistributionList, 'disabled': !selectedDistributionList
            }" (click)="onClickVisualizzaContenutoListaEmissione()"></button>
      <button pButton type="button" data-testid="createNewEmissionDistributionListBtn" *ngIf="!readOnly"
              class="buttonActions buttonCreaNuova" icon="fa fa-plus" iconPos="left"
              label="{{'campaign.create_new_list' | translate}}" (click)="onClickCreaNuovaLista()"></button>
    </div>


  </div>



  <!-- MODALI -->


  <!-- modale per le liste di distribuzione -->
  <p-dialog *ngIf="show.modalDistributionList && distributionList" [width]="1500" [height]="800"
            [(visible)]="show.modalDistributionList" [responsive]="true"
            [header]="'campaign.search_distribution_list' | translate" showEffect="fade" [modal]="true">


    <!-- Bottoni Annulla e Conferma -->
    <div class="ui-dialog-footer fixed-buttons buttonsContainer">
      <button pButton (click)="onClickAnnulla_ModalListDistribuzione()" data-testid="undoCloseModalDistribution"
              type="button" class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"></button>
      <div class="clear_fix"></div>
    </div>

    <app-campaign-3-search-distribution-list #searchDistributionListChallenge
                                             data-testid="searchDistributionListChallenge"
                                             (distributionListSelected)="onDistributionListSelected($event)"
                                             [distributionList]="distributionList"></app-campaign-3-search-distribution-list>


  </p-dialog>


  <!-- modale per i dettagli della lista -->
  <p-dialog *ngIf="show.modalDistributionListDetails" [width]="1500" [height]="800"
            [(visible)]="show.modalDistributionListDetails" [responsive]="true" [header]="provTitle" showEffect="fade"
            [modal]="true">


    <!-- Bottoni Annulla e Conferma -->
    <div class="ui-dialog-footer buttonsContainer">
      <button pButton (click)="onClickAnnulla_ModalListDistribuzioneDetails()" type="button"
              class="k-generic-btn footer-btn" label="{{'common.cancel' | translate}}"
              data-testid="closeModalDistribution"></button>
      <div class="clear_fix"></div>
    </div>

    <app-campaign-3-view-distribution-list-details #searchDistributionListDetails
                                                   data-testid="searchDistributionListDetails" [distributionListId]="currentDistributionListId"
                                                   [distributionListDetails]="distributionListDetails"></app-campaign-3-view-distribution-list-details>

  </p-dialog>


  <!-- modale per gli acm -->
  <p-dialog *ngIf="show.modalAcmList" [width]="1500" [height]="800" [(visible)]="show.modalAcmList"
            [responsive]="true" [header]="'challenge.search_accumulators' | translate " showEffect="fade" [modal]="true">

    <app-campaign-3-search-accumulators #searchAccumulators [accumulatorList]="listAccumulator"
                                        [multipleselection]="true" (acmSelected)="onAcmSelected($event)"></app-campaign-3-search-accumulators>


  </p-dialog>


  <!-- creaione lista distrib -->
  <p-dialog *ngIf="show.modalClusterHeadNewList" [width]="1500" [height]="800"
            [(visible)]="show.modalClusterHeadNewList" [responsive]="true" [header]="newList" showEffect="fade"
            [modal]="true">

    <app-campaign-3-create-cluster-head-list #createClusterHeadList data-testid="createClusterHeadListChallenge"
                                             (clusterHeadListSelected)="onAggiungiClusterHead($event)"
                                             (clusterHeadListCancel)="onAnnullaClusterHead($event)"
                                             [clusterHeadList]="clusterHeadNewList"
                                             [actionDateStart]="fieldModel.dateStart"
                                             [actionDateEnd]="fieldModel.dateEnd"></app-campaign-3-create-cluster-head-list>

  </p-dialog>


  <p-dialog *ngIf="show.modalLayoutTouchpoint" [width]="1500" [height]="800" [(visible)]="show.modalLayoutTouchpoint"
            [responsive]="true" [header]="'Layout'" showEffect="fade" [modal]="true"
            class="campaign-dialog fixed-title-dialog" focusOnShow="true">
    <button class="phantom-button" autofocus></button>
    <custom-schema-form *ngIf="currentSchema" [schema]="currentSchema" [form]="form" [model]="model"
                        (modelChange)="model = $event">
    </custom-schema-form>
    <div style="padding-left: 11px; margin-top: 15px;" *ngIf="!readOnly">
      <button pButton type="submit" class="k-generic-btn" label="{{ 'common.save' | translate }}"
              (click)="submitForm('touchpoint')" [disabled]="form.invalid">
      </button>
      <button pButton type="button" class="k-generic-btn" label="{{ 'common.cancel' | translate }}"
              (click)="closeLayoutTouchpointForm()">
      </button>
    </div>

  </p-dialog>


  <p-dialog *ngIf="show.modalLayoutDefault" [width]="1500" [height]="800" [(visible)]="show.modalLayoutDefault"
            [responsive]="true" [header]="'Challenge Layout Default'" showEffect="fade" [modal]="true"
            class="campaign-dialog fixed-title-dialog" focusOnShow="true">
    <button class="phantom-button" autofocus></button>
    <custom-schema-form *ngIf="currentSchema" [schema]="currentSchema" [form]="form" [model]="model"
                        (modelChange)="model = $event">
    </custom-schema-form>

    <div style="padding-left: 11px; margin-top: 15px;" *ngIf="!readOnly">
      <button pButton type="submit" class="k-generic-btn" label="{{ 'common.save' | translate }}"
              (click)="submitForm('default')" [disabled]="form.invalid">
      </button>
      <button pButton type="button" class="k-generic-btn" label="{{ 'common.cancel' | translate }}"
              (click)="closeLayoutDefaultForm()">
      </button>

    </div>
  </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge-creation/challenge-creation.component.html